import { MenuItem, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FilterMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  color: theme.palette.grey[800],
  width: '14rem',
}));

export const FilterStack = styled(Stack)({
  alignItems: 'center',
  padding: '0 0.5rem',
});

export const FilterToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  width: '100%',
  padding: '0.125rem',
  borderRadius: '2.25rem',
  backgroundColor: theme.palette.purple[50],

  '& .Mui-selected': {
    backgroundColor: 'white !important',
    borderRadius: '2.25rem',
  },
}));

export const FilterToggleButton = styled(ToggleButton)({
  width: '100%',
  textTransform: 'none',
  borderRadius: '2.25rem',
  paddingTop: 0,
  paddingBottom: 0,
  border: 'none !important',
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: '160%',
});
